import React from "react";

import { ITitleContext, TitleContext } from "./ViewContainer";

interface ITitledComponentProps {
    viewTitleContext: ITitleContext;
    viewTitle: string;
}

export interface IViewTitleProps {
    viewTitleContext: ITitleContext;
}

class TitledComponent extends React.Component<ITitledComponentProps> {
    public componentDidMount() {
        // Update view's title once we mount
        const ctx = this.props.viewTitleContext;
        ctx.changeTitle(this.props.viewTitle);
    }

    public render() {
        return this.props.children;
    }
};

function withTitle(title: string, Component: React.ComponentType<any>) {
    return (props: any) => (
        <TitleContext.Consumer>
            {
                value => (
                    <TitledComponent viewTitleContext={value} viewTitle={title}>
                        <Component {...props} viewTitleContext={value} />
                    </TitledComponent>
                )
            }
        </TitleContext.Consumer>
    );
}


export default withTitle;
